import api from './api';

export default {
  get: async (): Promise<string[]> => api.get('/api/v1/permissions/types'),
};
